import React from "react"

import {useGlobalState} from "../../../GlobalState";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import {usePricesCoverageQuery} from "../query";
import {formatISO} from "date-fns";

import CardContent from "@mui/material/CardContent";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch/Switch";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";


const AutoReplyCard = () => {
    const {settings, updateSettings} = useGlobalState();
    const requestAutoReplyEnabled = settings.requestAutoReplyEnabled;
    const emailProvider = settings.emailProvider;
    const {askConfirmation, showSuccessNotification, showErrorNotification} = useFeedbackTools();

    const today = new Date();
    const nextYear = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());

    const priceCoverageQuery = usePricesCoverageQuery(
        requestAutoReplyEnabled,
        formatISO(today, {representation: "date"}),
        formatISO(nextYear, {representation: "date"})
    );

    const priceCoverage = priceCoverageQuery.data ? priceCoverageQuery.data.coverage : null;

    const label= requestAutoReplyEnabled ?
        "Risposte automatiche abilitate"
        :
        "Risposte automatiche non abilitate, clicca per abilitare";

    const handleToggleAutoReply = async () => {
        try{
            await updateSettings({requestAutoReplyEnabled: !requestAutoReplyEnabled})
            showSuccessNotification("Modifiche salvate");
        }
        catch(e){
            showErrorNotification(e)
        }
    }

    const handleOnClick= async () => {
        if(!requestAutoReplyEnabled && emailProvider === "default"){
            askConfirmation({
                title: "Risposte automatiche",
                description: "Le risposte automatiche posso essere abilitate solamente se si utilizza Gmail o SMTP come servizio di invio email.",
                onConfirm: f=>f,
                disableClose: true
            })
        }
        else{
            if (!requestAutoReplyEnabled){
                askConfirmation({
                    title: "Risposte automatiche",
                    cancellationText: "Annulla",
                    description: "Verrà creato e inviato un preventivo in automatico per tutte le richieste di prenotazione non filtrate. Verranno proposte le sole strutture disponibili e il prezzo sarà calcolato in base alle tue tariffe. Per i periodi non disponibili saranno proposte date alternative. Tutte le richieste per cui non è possible creare un preventivo saranno processate normalmente e inoltrate al tuo indirizzo.",
                    onConfirm: () => handleToggleAutoReply()
                })
            }
            else{
                handleToggleAutoReply()
            }
        }
    }

    return <Card>
        <CardContent>
            <Container maxWidth='sm' disableGutters>
                <Stack spacing={2}>
                    <Typography textAlign="justify" mt={2}>
                        Abilita le risposte automatiche per rispondere alle richieste di prenotazione in
                        maniera automatica con preventivi calcolati in base alle tue tariffe e disponibilità.
                    </Typography>
                    {
                        requestAutoReplyEnabled && <CoverageStatus coverage={priceCoverage}/>
                    }
                    <FormGroup>
                        <FormControlLabel control={<Switch checked={requestAutoReplyEnabled}
                                                           onChange={handleOnClick}/>}
                                          label={label} />
                    </FormGroup>
                </Stack>
            </Container>
        </CardContent>
    </Card>
}

const CoverageStatus = ({coverage}) => {
    if(coverage === null){
        return null;
    }
    if(coverage >= 0.9){
        return <Alert severity="success">
            Bene! I prezzi per i prossimi 12 mesi sono configurati per più del 90% dei giorni.
        </Alert>
    }
    if(coverage >= 0.5){
        return <Alert severity="warning">
            Attenzione! I prezzi per i prossimi 12 mesi sono configurati solo parzialmente, aggiornali nella sezione "Tariffe".
        </Alert>
    }
    if(coverage >= 0.1){
        return <Alert severity="error">
            Attenzione! La maggior parte dei prezzi per i prossimi 12 mesi non è configurata, aggiornali nella sezione "Tariffe".
        </Alert>
    }
    return <Alert severity="error">
        Attenzione! I prezzi per i prossimi 12 mesi non sono configurati, aggiornali nella sezione "Tariffe".
    </Alert>
}

export default AutoReplyCard;